// This file is loaded before the app.ts, so there can't be any references to the app.ts
import { VideoAdTop } from '$src/js/modules/video-ad-top/videoAdTop';

new VideoAdTop();
